import {
  required,
  phone,
  email,
  taxpayerId,
  legalName,
  legalTermsAccepted,
} from './formValidations';

const purchaserValidations = {
  purchaserFirstName: required,
  purchaserLastName: required,
  email: [required, email],
  phone: [required, phone],
  phoneCountry: [required],
  taxpayerId,
  taxpayerLegalName: legalName,
  legalTerms: legalTermsAccepted,
};

export default purchaserValidations;
